import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      backgroundColor: theme.palette.grey[400],
      boxSizing: "border-box",
      fontFamily: theme.typography.fontFamily,
    },

    tableWrapper: {
      width: "100%",
      height: "fit-content",
      backgroundColor: theme.palette.grey[400],
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: "6px",
      boxSizing: "border-box",
      overflow: "hidden",

      "& > .MuiPaper-root": {
        width: "100%",
        backgroundColor: "transparent",
      },

      "& .MuiTableContainer-root": {
        minHeight: "unset !important",
        height: "fit-content",
        width: "100%",
        maxWidth: "100%",
      },

      "& .MuiTable-root": {
        width: "100%",
        borderCollapse: "collapse",
        background: `${theme.palette.grey[400]} !important`,
        backgroundColor: `${theme.palette.grey[400]} !important`,
        fontFamily: theme.typography.fontFamily,
      },

      "& .MuiTableCell-root": {
        padding: "8px 12px",
        fontSize: "14px",
        textAlign: "right",
        whiteSpace: "nowrap",
        fontFamily: theme.typography.fontFamily,
        border: "none !important",
        borderBottom: `1px solid ${theme.palette.divider} !important`,
      },

      "& .MuiTableHead-root .MuiTableRow-root": {
        height: "52px",
      },

      "& .MuiTableHead-root .MuiTableCell-head, & [class*='cellHead']": {
        height: "52px !important",
        minHeight: "52px !important",
        maxHeight: "52px !important",
        padding: "0 12px !important",
        boxSizing: "border-box",
        border: "none !important",
        borderBottom: `1px solid ${theme.palette.divider} !important`,
        fontFamily: `${theme.typography.fontFamily} !important`,
        fontWeight: "500 !important",
        fontStyle: "normal !important",
        fontSize: "14px !important",
        lineHeight: "21px !important",
        letterSpacing: "0 !important",
        textAlign: "right !important" as "right",
        whiteSpace: "nowrap",
        background: `${theme.palette.grey[400]} !important`,
        backgroundColor: `${theme.palette.grey[400]} !important`,
        color: `${theme.palette.text.primary} !important`,
      },

      "& .MuiTableBody-root .MuiTableRow-root": {
        height: "52px",
        backgroundColor: `${theme.palette.background.paper} !important`,
      },

      "& .MuiTableBody-root .MuiTableCell-root": {
        height: "52px !important",
        minHeight: "52px !important",
        maxHeight: "52px !important",
        padding: "0 12px !important",
        boxSizing: "border-box",
        border: "none !important",
        borderBottom: `1px solid ${theme.palette.divider} !important`,
        backgroundColor: `${theme.palette.background.paper} !important`,
        color: `${theme.palette.secondary.main} !important`,
        fontFamily: `${theme.typography.fontFamily} !important`,
        fontWeight: "400 !important",
        fontStyle: "normal !important",
        fontSize: "14px !important",
        lineHeight: "21px !important",
        letterSpacing: "0 !important",
        textAlign: "right !important" as "right",
      },

      "& .MuiTableBody-root .MuiTableRow-root:nth-of-type(even)": {
        backgroundColor: `${theme.palette.background.paper} !important`,
      },

      "& .MuiTableBody-root .MuiTableRow-root:hover": {
        backgroundColor: `${theme.palette.background.tableRowHover} !important`,
      },

      "& .MuiTableBody-root .MuiTableRow-root:hover .MuiTableCell-root": {
        backgroundColor: `${theme.palette.background.tableRowHover} !important`,
      },
    },

    statusChip: {
      minWidth: 66,
      height: 26,
      minHeight: 26,
      padding: "0 10px",
      borderRadius: 4,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme.palette.common.white,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "21px",
      fontFamily: theme.typography.fontFamily,
      boxSizing: "border-box",
    },

    draftChip: {
      backgroundColor: theme.palette.priceQuoteStatus.draft,
    },

    sentChip: {
      backgroundColor: theme.palette.priceQuoteStatus.sent,
    },

    acceptedChip: {
      backgroundColor: theme.palette.priceQuoteStatus.accepted,
    },
  })
);
